var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('site-header'),_c('router-view'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }